import crudHandlers from './_crud'

const entity = 'chat_passenger'
const initialState = {
	entities: {},
	unreadMessages: [],
	activeChatId: null
}

export default (state = initialState, action) => {
	const { type, payload } = action

	switch (type) {
		case 'UPDATE_CHAT': {
			const currentChat = state.entities[payload.id] || {}

			return {
				...state,
				entities: {
					...state.entities,
					[payload.id]: {
						...currentChat,
						...payload.data,
					},
				},
			}
		}
		case 'LOAD_WITH_LAST_MESSAGE': {
			const chats = payload.reduce((acc, chat) => {
				acc[chat.id] = chat
				return acc
			}, {})

			return {
				...state,
				entities: {
					...state.entities,
					...chats,
				},
			}
		}
		case 'LOAD_MESSAGES': {
			const chat = state.entities[payload.id] ?? {}

			return {
				...state,
				entities: {
					...state.entities,
					[payload.id]: {
						...chat,
						Messages: payload.data,
						lastMessage: payload.data[payload.data.length - 1],
					},
				},
			}
		}
		case 'SET_NEW_MESSAGE': {
			const { chat, lastMessage } = payload.data
			const item = state.entities[payload.id] || chat
			const prevMessages = state.entities[payload.id]?.Messages

			// const unreadMessages = isUnreadMessage ? [...state.unreadMessages, lastMessage] : state.unreadMessages

			// Si no hay mensajes previos, inicializar con el nuevo mensaje
			// Si hay mensajes previos, agregar el nuevo mensaje al final
			// Si no hay mensajes previos, inicializar con el nuevo mensaje
			// Si hay mensajes previos, agregar el nuevo mensaje al final
			// FIX: Allow initialization if it's our own message (sending to new chat)
			const shouldAddMessage = (prevMessages && Array.isArray(prevMessages)) || payload.isOwnMessage
			
			const newMessages = shouldAddMessage
				? [...(prevMessages || []), lastMessage] 
				: undefined

			return {
				...state,
				entities: {
					...(state.entities || {}),
					[payload.id]: {
						...item,
						Messages: newMessages || undefined,
						lastMessage,
						hasMessages: true,
					},
				},
			}
		}
		case 'UPDATE_MESSAGES': {
			const item = state.entities[payload.id]
			const prevMessages = item?.Messages

			if (!prevMessages) return state

			const messages = prevMessages.map((m) => {
				const newMessage = payload.data.find((msg) => {
					if (msg.tempId) return msg.tempId === m.id
					return msg.id === m.id
				})

				if (newMessage) {
					return newMessage
				}
				return m
			})
			const lastMessage = messages.length
				? messages[messages.length - 1]
				: state.entities[payload.id]?.lastMessage

			return {
				...state,
				entities: {
					...(state.entities || {}),
					[payload.id]: {
						...item,
						Messages: messages,
						lastMessage,
					},
				},
			}
		}
		case 'MARK_AS_READ': {
			const { chatId, userId, clientContactId } = payload
			const item = state.entities[chatId]
			const { unreadMessages } = state
			const prevMessages = item?.Messages

			if (!prevMessages) return state

			const messages = prevMessages.map(m => {
				if (m.user_id && m.user_id === userId) return m
				if (m.client_contact_id && m.client_contact_id === clientContactId) return m
				
				// Check if already read by this user
				const isRead = m.read_by.some(r => {
					if (userId) return r.user_id === userId
					if (clientContactId) return r.client_contact_id === clientContactId
					return false
				})

				if (isRead) return m

				// Add to read_by
				const newRead = {
					date: new Date().toISOString(),
					...(userId ? { user_id: userId } : {}),
					...(clientContactId ? { client_contact_id: clientContactId } : {})
				}

				return {
					...m,
					read_by: [...m.read_by, newRead]
				}
			})

			const lastMessage = messages.length ? messages[messages.length - 1] : item.lastMessage
			const filteredUnread = unreadMessages.filter((m) => m.chat_id !== chatId)

			return {
				...state,
				entities: {
					...(state.entities || {}),
					[chatId]: {
						...item,
						Messages: messages,
						lastMessage: lastMessage
					},
				},
				unreadMessages: filteredUnread,
			}
		}
		case 'SET_UNREAD_MESSAGES': {
			console.log('SET_UNREAD_MESSAGES', payload)
			return {
				...state,
				unreadMessages: (payload || []),
			}
		}
		case 'SET_ACTIVE_CHAT_ID': {
			return {
				...state,
				activeChatId: action.payload
			}
		}
		case 'DELETE_CHAT_PASSENGER': {
			const newEntities = { ...state.entities }
			delete newEntities[payload]
			return {
				...state,
				entities: newEntities
			}
		}
		case 'LOGOUT':
		case 'CLIENT_LOGOUT':
		case 'DRIVER_LOGOUT':
		case 'PASSENGER_LOGOUT':
			return initialState

		default:
			state = crudHandlers(state, action, entity)

			return state
	}
}
